import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const FOOTER_LINKS = [
  { to: "/", label: "Home" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/plans", label: "Plans" },
  { to: "/reviews", label: "Reviews" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer
      className="relative bg-slate-900 text-white pt-16 pb-8 overflow-hidden"
      data-testid="site-footer"
    >
      <div className="container-page relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 md:gap-10">
          <div className="lg:col-span-5 flex flex-col gap-5">
            <div className="flex items-center gap-4">
              <img
                src="/logo-badge.jpg"
                alt="Silky Smooth Trash Bin Service badge"
                className="h-16 w-16 rounded-full object-cover ring-2 ring-white/10"
                draggable={false}
              />
              <div className="font-heading text-2xl font-bold tracking-tight text-white leading-tight">
                Silky Smooth
                <span className="block text-sm text-white/60 font-sans tracking-wide font-normal">
                  Trash Bin Service
                </span>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-sm">
              Premium trash bin cleaning for South Jersey. Eco-friendly,
              odor-eliminating, and reliable. We pick up where the trash truck
              leaves off.
            </p>
            <div className="text-xs text-gold-300 tracking-[0.18em] uppercase font-semibold">
              Owned &amp; operated by Isaac Arif
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.22em] text-gold-300 mb-5 font-sans font-semibold">
              Explore
            </h4>
            <ul className="space-y-3 text-sm">
              {FOOTER_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/75 hover:text-brand-200 transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-gold-300 mb-5 font-sans font-semibold">
              Service Area
            </h4>
            <ul className="space-y-3 text-sm text-white/75">
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 text-brand-300" />
                Pine Hill and nearby South Jersey communities
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-gold-300 mb-5 font-sans font-semibold">
              Reach Us
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:silkysmoothpowerwash@gmail.com"
                  className="flex items-center gap-2 text-white/75 hover:text-brand-200 transition-colors break-all"
                  data-testid="footer-email"
                >
                  <Mail size={14} className="text-brand-300 shrink-0" />
                  silkysmoothpowerwash@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+19452722414"
                  className="flex items-center gap-2 text-white/75 hover:text-brand-200 transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={14} className="text-brand-300" />
                  (945) 272-2414
                </a>
              </li>
              <li className="text-white/60 text-xs leading-relaxed pt-2">
                Mon to Sat · 8 am to 6 pm
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 mb-6 h-px bg-white/10" />

        <div className="flex flex-col-reverse md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/55">
          <p>© 2026 Silky Smooth Trash Bin Service. All rights reserved.</p>
          <p className="tracking-wide">
            Proudly serving Pine Hill and nearby South Jersey communities
          </p>
        </div>
      </div>
    </footer>
  );
}
